import Vue from "vue";
import Vuex from "vuex";
import actions from "./actions";
import mutations from "./mutations";

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        loadArticlesStatus: {
            status: "empty",
            Message: "",
        },
        remoteArticle: {
            status: "empty",
            errorMessage: "",
            data: null,
        },
        remoteCategory: {
            status: "empty",
            errorMessage: "",
            data: null,
        },
        loadCategoryStatus: "",
        textSearchQuery: "",
        categoryId: "",
    },
    mutations,
    actions,
});

export default store;
